import * as React from 'react';
import { Typography } from '@mui/material';


const DashboardHome = () => {
    return (
        <Typography paragraph>
        content here
        </Typography>
    );
};

export default DashboardHome;